import { useEffect, useState } from "react";
import { updateKeywordMappingSelectionData, updateProductMappingSelectionData } from "@features/selectedDataSlice";
import { updateKeywordMappingFilterModel, updateProductMappingFilterModel } from "@features/modalSlice";
import Layout from "@wrappers/layouts/main-layout/Layout";
import $ from "jquery";
import { Tabs, TabsProps } from "antd";
import GeneralSettings from "./general-settings/GeneralSettings";
import AddTagTypeModal from "./tags-settings/AddTagTypeModal";
import TagsComponent from "./tags-settings/TagsComponent";
import ProductMapping from "./mapping-grids/ProductMapping";
import { getClientTagsList } from "@ts/utils";
import { filter, map } from "underscore";
import { useDispatch, useSelector } from "react-redux";
import { IChannel, ITagMappingStats, ParentModule, TActiveClientId, TTagType } from "@ts/common-types";
import { useNavigate } from "react-router-dom";
import { useClearGridData, usePermissionCheck } from "@hooks/AllCustomHooks";
import KeywordMapping from "./mapping-grids/KeywordMapping";
import PfmTagsStatusModal from "@components/modals/PfmTagsStatusModal";
import { TAG_MAPPING_STATS_DEFAULT_VALUE } from "@ts/constants";
import * as Sentry from "@sentry/react";

const Settings = () => {
    const dispatch = useDispatch();
    const clearGridData = useClearGridData();
    const activeClientId = useSelector(
        (state: TActiveClientId) => state.activeClientId.value
    );
    const channel = useSelector((state: IChannel) => state.channel.value);
    const clientIdOnChannelChange = useSelector(
        (state: { clientIdOnChannelChange: { value: string } }) =>
            state.clientIdOnChannelChange.value
    );
    const [isAddTagTypeModalVisible, setIsTagTypeModalVisible] =
        useState<boolean>(false);
    const [selectedTagType, setSelectedTagType] = useState("global");
    const [tagTypes, setTagTypes] = useState<TTagType[]>([]);
    const [showPfmTagsStatusModal, setShowPfmTagsStatusModal] = useState<boolean>(false);
    const [tagsMappingStats, setTagsMappingStats] = useState<ITagMappingStats>(TAG_MAPPING_STATS_DEFAULT_VALUE);

    const navigate = useNavigate();

    useEffect(() => {
        clearGridData();
    }, [activeClientId, dispatch, channel]);

    // for initial tag page load
    useEffect(() => {
        getClientTagsList()
            .then((clientTagTypes) => {
                const recordTypeTags = map(
                    filter(
                        clientTagTypes,
                        (tagType) => tagType.record_type === selectedTagType
                    ),
                    (type) => ({
                        id: type.tag_type_id,
                        tag_type: type.tag_type,
                        is_default: type.is_default
                    })
                );

                setTagTypes(recordTypeTags);
            })
            .catch((error) => {
                console.error(error);
                Sentry.captureException(error);
            });
    }, [activeClientId, channel]);

    const { canListTags } = usePermissionCheck();
    const [currentTab, setCurrentTab] = useState<string>("general");

    const productMappingComponent = (
        <ProductMapping
            key={`product-mapping-${currentTab === "product-mapping" ? "active" : "inactive"}`}
            tagsMappingStats={tagsMappingStats}
            setTagsMappingStats={setTagsMappingStats}
            showPfmTagsStatusModal={showPfmTagsStatusModal}
            setShowPfmTagsStatusModal={setShowPfmTagsStatusModal}
            clientIdOnChannelChange={clientIdOnChannelChange}
        />
    );

    const keywordMappingComponent = (
        <KeywordMapping
            key={`keyword-mapping-${currentTab === "keyword-mapping" ? "active" : "inactive"}`}
            tagsMappingStats={tagsMappingStats}
            setTagsMappingStats={setTagsMappingStats}
            // showPfmTagsStatusModal={showPfmTagsStatusModal}
            setShowPfmTagsStatusModal={setShowPfmTagsStatusModal}
            clientIdOnChannelChange={clientIdOnChannelChange}
        />
    );

    let items: TabsProps["items"] = [
        {
            key: "general",
            label: "General",
            children: <GeneralSettings />,
        },
        {
            key: "tags",
            label: "Tags",
            children: (
                <TagsComponent
                    isAddTagTypeModalVisible={isAddTagTypeModalVisible}
                    setIsTagTypeModalVisible={setIsTagTypeModalVisible}
                    selectedTagType={selectedTagType}
                    setSelectedTagType={setSelectedTagType}
                    tagTypes={tagTypes}
                    setTagTypes={setTagTypes}
                />
            ),
        },
        {
            key: "product-mapping",
            label: "Product Mapping",
            children: productMappingComponent,
        },
        {
            key: "keyword-mapping",
            label: "Keyword Mapping",
            children: keywordMappingComponent,
        },
    ];

    if (!canListTags) {
        items = items.filter((item) => item.label !== "Tags");
    }

    const getActiveKey = items.filter(
        (item) => item.key === window.location.pathname.split("/").pop()
    );

    return (
        <>
            <Layout>
                <div className="settings-container">
                    <Tabs
                        size="large"
                        activeKey={getActiveKey[0]?.key || "general"}
                        items={items}
                        onChange={(key) => {
                            setCurrentTab(key);
                            
                            const dropDown = $("#pa-bulk-action-drop-down");
                            if (dropDown.length) {
                                dropDown.hide();
                                dropDown.remove();
                            }

                            dispatch(updateKeywordMappingSelectionData([]));
                            dispatch(updateKeywordMappingFilterModel({}));
                            dispatch(updateProductMappingSelectionData([]));
                            dispatch(updateProductMappingFilterModel({}));

                            navigate(`/${ParentModule.SETTINGS}/${key}`);
                        }}
                        destroyOnHidden={true}
                    />
                    {isAddTagTypeModalVisible ? (
                        <AddTagTypeModal
                            isAddTagTypeModalVisible={isAddTagTypeModalVisible}
                            setIsTagTypeModalVisible={setIsTagTypeModalVisible}
                        />
                    ) : null}
                </div>
            </Layout>
            {
                    showPfmTagsStatusModal && <PfmTagsStatusModal show={showPfmTagsStatusModal} setShow={setShowPfmTagsStatusModal} data={tagsMappingStats} />
            }
        </>
        
    );
    
};

export default Settings;